import React, { useContext, useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import ContactNote from 'src/models/ContactNote';
import LeaseGenerationOwnerData from 'src/models/leasing/LeaseGenerationOwnerData';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';
import useFetch from 'use-http';
// import OwnerTracts from '../owners/OwnerTracts';
import Ownership from 'src/models/tract_detail/Ownership';
import OwnershipTractList from '../../TractComponents/OwnershipTractList';
import moment from 'moment';
import Dialog from 'src/components/common/Dialog.redesign';

interface IContactNoteDialogStateProps {
    ownership?: Ownership;
    createNewNote?: boolean;
    projectType?: 'Mineral' | 'Surface';

    refreshContainer?: () => void;
    onCloseDialog?: () => void;
}

// TODO: Replace this across the application with the Manage Ownership Dialog page.
const ContactNoteDialog: React.FC<IContactNoteDialogStateProps> = (props: IContactNoteDialogStateProps) => {
    const { register, handleSubmit, reset } = useForm();
    const appContext = useContext<IAppContextState>(AppContext);
    const { get, response, post, put } = useFetch();
    const [contactNote, setContactNote] = useState<ContactNote>(null);
    const [saveComplete, setSaveComplete] = useState(false);
    const [ownerDetail, setOwnerDetail] = useState<LeaseGenerationOwnerData>(null);
    const [selectedOwnershipIds, setSelectedOwnershipIds] = useState<Array<number>>([]);

    const getOwnerDetail = async () => {
        let ownerLookupId =
            props.ownership != null ? props.ownership?.ownerLookUpId : 0;

        const result: LeaseGenerationOwnerData = await get(
            `/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/leasegeneration/owner/${ownerLookupId}`
        );

        if (response.ok) {
            setOwnerDetail(result);
            setContactNote(result.contactNotes.find((x) => x.ownershipId === props.ownership?.id));

            const currentContactNoteOwnershipId = result.contactNotes.find((x) => x.ownershipId === props.ownership?.id)?.id;

            let ownershipIdsTemp = result.contactNotes.filter((x) => x.id === currentContactNoteOwnershipId).map((x) => x.ownershipId);
            console.log('temp ownerhsip id', ownershipIdsTemp);
            if (!!ownershipIdsTemp.every((s) => s === 0)) {
                setSelectedOwnershipIds([]);
            } else {
                setSelectedOwnershipIds(result.contactNotes.filter((x) => x.id === currentContactNoteOwnershipId).map((x) => x.ownershipId));
            }
        }
    };

    const createContactNote = async (newContactNote: ContactNote) => {
        if (props.ownership != null) {
            await post(`/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/contact-notes`, newContactNote).then(() =>
                handleSuccessfulSave()
            );
        }

        if (response.ok) {
            setSaveComplete(true);
            setTimeout(() => setSaveComplete(false), 2000);
            props.onCloseDialog();
        }
    };

    const updateContactNote = async (newContactNote: ContactNote) => {
        if (props.ownership != null) {
            await put(`/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/contact-notes`, newContactNote).then(() =>
                handleSuccessfulSave()
            );
        }

        if (response.ok) {
            setSaveComplete(true);
            setTimeout(() => setSaveComplete(false), 2000);
            props.onCloseDialog();
        } else {
            console.log('error on the put', response);
        }
    };

    const handleSuccessfulSave = () => {
        getOwnerDetail();

        if (props.refreshContainer) {
            props.refreshContainer();
        }
    };

    useEffect(() => {
        if (props.ownership?.id > 0) {
            getOwnerDetail();
        }
    }, [props.ownership?.id]);

    useEffect(() => {
        initializeData();
    }, [ownerDetail]);

    const onSubmit = (data: ContactNote, event: React.FormEvent<HTMLFormElement>) => {
        event.stopPropagation();

        data = finalizeData(data);

        if (data.id === 0) {
            data.createdDate = new Date();
            data.createdById = Number(appContext.currentUser.userId);

            createContactNote(data);
        } else {
            updateContactNote(data);
        }
    };

    const finalizeData = (data: ContactNote) => {
        data.id = Number(contactNote?.id || 0);

        data.modifiedDate = new Date();
        data.modifiedById = Number(appContext.currentUser.userId);

        data.ownershipId = props.ownership?.id;
        data.ownershipIds = selectedOwnershipIds;

        console.log('data to be submitted', data);
        console.log('selected ownershipIds to be put into data', selectedOwnershipIds);

        return data;
    };

    const initializeData = () => {
        const blankContactNote: ContactNote = {
            id: 0,
            note: null,
            ownershipId: null,
            modifiedById: 0,
            modifiedDate: new Date(),
            createdById: 0,
            createdDate: new Date(),
        };

        if (ownerDetail?.contactNotes) {
            const contactNotesForCurrentOwnership = ownerDetail.contactNotes.filter(
                (x) => x.ownershipId === props.ownership?.id
            );

            setSelectedOwnershipIds(contactNotesForCurrentOwnership.map((x) => x.ownershipId));

            reset(contactNotesForCurrentOwnership[0] || blankContactNote);
            setContactNote(contactNotesForCurrentOwnership[0] || blankContactNote);
        } else {
            reset(blankContactNote);
            setContactNote(blankContactNote);
        }
    };

    const onUpdateSelectedOwnershipIds = (ownershipId: number) => {
        let newSelectedOwnershipIds = [];
        if (selectedOwnershipIds.indexOf(ownershipId) > -1) {
            newSelectedOwnershipIds = selectedOwnershipIds.filter((x) => x !== ownershipId);
        } else {
            newSelectedOwnershipIds = [...selectedOwnershipIds, ownershipId];
        }
        setSelectedOwnershipIds(newSelectedOwnershipIds);
    };

    const onSelectAllOwnerships = (selectAll: boolean) => {
        if (selectAll === true) {
            let allIds = ownerDetail.tracts.map(tr => tr.ownershipId);
            setSelectedOwnershipIds(allIds);
        } else {
            setSelectedOwnershipIds([]);
        }
    };

    const showSelectedGlobalIds = () => {
        if (selectedOwnershipIds.length > 0) {
            return selectedOwnershipIds.map((selectedOwnershipId: number, index) => {
                const tempTract = ownerDetail?.tracts.find((x) => x.ownershipId === selectedOwnershipId);
                if (tempTract) {
                    const tempGlobalId = `${tempTract.sectionNumber}.${tempTract.tractNumber}-${tempTract.horizonNumber}`;
                    return (
                        <>
                            <span key={index}>{tempGlobalId}</span>
                            {index < selectedOwnershipIds.length - 1 ? <span>, </span> : null}
                        </>
                    );
                } else {
                    return <span />;
                }
            });
        } else {
            return <span />;
        }
    };

    return (
        <Dialog title="Contact Notes">
            <div style={{ display: 'flex', width: '60vw' }}>
                <div style={{ width: '50%', borderRight: '1px solid grey', margin: '.5rem', paddingRight: '1rem' }}>
                    {contactNote && (
                        <>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div>Note</div>
                                    <div>
                                        <span style={{ marginRight: '1rem' }}>Attached Tracts:</span>
                                        {showSelectedGlobalIds()}
                                    </div>
                                </div>
                                <textarea
                                    name="note"
                                    id="note"
                                    ref={register}
                                    style={{ width: '100%', minHeight: '30rem', border: '0', borderBottom: '1px solid grey' }}
                                />
                                <br />
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <input
                                        type="submit"
                                        value={saveComplete ? 'Save Complete!' : 'Save'}
                                        style={
                                            selectedOwnershipIds?.length > 0
                                                ? { border: '0', backgroundColor: '#6393C1', color: 'white', height: '3rem' }
                                                : { border: '0', backgroundColor: '#bbbbbb', color: 'darkgrey', height: '3rem' }
                                        }
                                        disabled={!(selectedOwnershipIds?.length > 0)}
                                    />
                                    {selectedOwnershipIds?.length === 0 && <div>No Tracts selected</div>}
                                    <div>{`Last Modified: ${moment(contactNote?.modifiedDate).format('MM/DD/YYYY')}`}</div>
                                </div>
                            </form>
                        </>
                    )}
                    {!contactNote && <div>Loading...</div>}
                </div>
                <div style={{ margin: '.5rem', width: '50%' }}>
                    {ownerDetail?.tracts && (
                        <>
                            <div>Tract List</div>
                            <div style={{ maxHeight: '40rem', overflowY: 'auto', overscrollBehavior: 'contain', paddingTop: '.5rem' }}>
                                <OwnershipTractList
                                    tracts={ownerDetail?.tracts}
                                    clientNumber={appContext.clientNumber}
                                    projectNumber={appContext.projectNumber}
                                    selectedOwnershipIds={selectedOwnershipIds}
                                    projectType={props.projectType}
                                    updateSelectedOwnershipIds={onUpdateSelectedOwnershipIds}
                                    selectAllOwnerships={onSelectAllOwnerships}
                                />
                            </div>
                        </>
                    )}
                </div>
            </div>
        </Dialog>
    );
};

export default ContactNoteDialog;



// WEBPACK FOOTER //
// ./src/components/project/sections/tract/dialogs/ContactNoteDialog.tsx